// ─── Progress Bar ─────────────────────────────────────────────────────────────
export const ProgressBar = ({ produced, required, mode }) => {
  const pct = required > 0 ? Math.min((produced / required) * 100, 100) : 0;
  const color = pct === 100 ? "#12B76A" : pct > 50 ? "#4164E3" : "#F79009";
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <div
        style={{
          width: "100%",
          height: 6,
          borderRadius: 4,
          backgroundColor: mode ? "#3a3c42" : "#E4E7EB",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            borderRadius: 4,
            backgroundColor: color,
            transition: "width 0.4s ease",
          }}
        />
      </div>
      <span style={{ fontSize: 10, color: mode ? "#aaa" : "#6B7280" }}>
        {produced} / {required} ({Math.round(pct)}%)
      </span>
    </div>
  );
};
